import { render, staticRenderFns } from "./CSVModal.vue?vue&type=template&id=642bcfc8&scoped=true&"
import script from "./CSVModal.vue?vue&type=script&lang=js&"
export * from "./CSVModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642bcfc8",
  null
  
)

export default component.exports